<template>
  <block-item-card
    :min-height="150"
    :title="cardTitle"
    :title-icon="'true'"
    :title-icon-class="'mdi-arrow-right'"
    :title-margin-top="'0px'"
    :title-icon-size="14"
  >
    <div class="pa-5 pt-1">
      <div
        class="item-chart-legend-container mb-2"
        :style="BankReadiness.survived ? 'background-color: var(--v-synthesis-ui-green-08-base); color: var(--v-synthesis-ui-green-00-base);' : 'background-color: var(--v-synthesis-ui-red-08-base); color: var(--v-synthesis-ui-red-00-base);'"
      >
        <span
          class="item-chart-legend-title d-flex align-center"
        >
          <crisis-survival-icon :survived="BankReadiness.survived" />
          <span class="ml-2 font-weight-bold">{{ $t('RiskLiquidity.Section.DefenceReadiness.DefenceReadinessOutcome.SurvivalDays') }}</span>

        </span>
        <span class="item-chart-legend-value ">
          {{ survivalDays }} {{ $t('RiskLiquidity.Section.DefenceReadiness.DefenceReadinessOutcome.Days') }}
        </span>
      </div>
      <div
        class="item-chart-legend-container mb-2"
        style="background-color: var(--v-synthesis-ui-grey-06-base);"
      >
        <span class="item-chart-legend-title ">
          {{ $t('RiskLiquidity.Section.DefenceReadiness.DefenceReadinessOutcome.SurvivalDaysWithdrawn') }}
        </span>
        <span class="item-chart-legend-value ">
          {{ riskBaseCurrencyDisplayName }}{{ survivalDaysWithdrawn }}
        </span>
      </div>
      <div
        class="item-chart-legend-container"
        style="background-color: var(--v-synthesis-ui-grey-06-base);"
      >
        <span class="item-chart-legend-title ">
          {{ $t('RiskLiquidity.Section.DefenceReadiness.DefenceReadinessOutcome.SurvivalDaysDeployed') }}
        </span>
        <span class="item-chart-legend-value ">
          {{ riskBaseCurrencyDisplayName }}{{ survivalDaysDeployed }}
        </span>
      </div>
    </div>
  </block-item-card>
</template>

  <script>
import BlockItemCard from '@/theme/default/components/common/BlockItemCard'
import { toDecimalSignificant, toNumberFormatNotationShort } from '@/lib/utils/helper'
import riskBaseCurrency from '@/theme/default/views/risks/mixins/riskBaseCurrency'
import CrisisSurvivalIcon from '@/theme/default/components/common/icons/CrisisSurvivalIcon'

export default {
  name      : 'DefenceReadinessOutcome',
  components: {
    BlockItemCard,
    CrisisSurvivalIcon
  },
  mixins   : [riskBaseCurrency],
  dataStore: {
    SelectedScenario    : 'RiskLiquidity.CrisisScenario.SelectedScenario',
    BankReadiness       : 'RiskLiquidity.BankReadiness.Data',
    riskBaseCurrencyData: 'Risks.BaseCurrency.Data'
  },
  data () {
    return {}
  },
  computed: {
    id () {
      return this.user?.selectedAccountId || null
    },
    selectedScenario () {
      return this.SelectedScenario
    },
    cardTitle () {
      // string replace # in the following with the selected scenario
      if (this.selectedScenario) {
        return this.$t('RiskLiquidity.Section.DefenceReadiness.DefenceReadinessOutcome.Title').replace('#', this.$t(`RiskLiquidity.Section.DefenceReadiness.CrisisScenarios.Scenarios.${this.selectedScenario}.Title`))
      } else {
        return this.$t('RiskLiquidity.Section.DefenceReadiness.DefenceReadinessOutcome.EditedScenarioTitle')
      }
    },
    survivalDays () {
      return this.BankReadiness.survivalDays ? toDecimalSignificant(this.BankReadiness.survivalDays) : ''
    },
    survivalDaysWithdrawn () {
      return this.BankReadiness.survivalDaysWithdrawn ? toNumberFormatNotationShort(this.BankReadiness.survivalDaysWithdrawn) : ''
    },
    survivalDaysDeployed () {
      return this.BankReadiness.survivalDaysDeployed ? toNumberFormatNotationShort(this.BankReadiness.survivalDaysDeployed) : ''
    }

  },
  mounted () {
  },
  methods: {
    selectCrisis (crisisType) {
      this.selectedCrisis = crisisType
      // Emit event or handle crisis selection
      this.$emit('crisis-selected', crisisType)
    }
  }
}
  </script>

  <style scoped>
  .item-chart-legend-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border-radius: 4px;
    height: 42px;
  }

  .item-chart-legend-title {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    margin-left: 8px;
  }

  .item-chart-legend-value {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.2px;
    line-height: 24px;
    margin-right: 8px;
  }
  </style>
